import React from "react"
import PropTypes from "prop-types"

import { TAB_GENERAL, TAB_PEDIDOS } from "../static"

const TABS = [
  { id: TAB_GENERAL, titulo: "General", icono: "bx bx-copy-alt" },
  { id: TAB_PEDIDOS, titulo: "Pedidos", icono: "bx bx-package" },
]

const ResumenTabs = ({ activa, onChange }) => (
  <div className="res-tabs res-anim">
    {TABS.map(tab => (
      <button
        key={tab.id}
        type="button"
        className={`res-tab${activa === tab.id ? " is-active" : ""}`}
        onClick={() => onChange(tab.id)}
      >
        <i className={tab.icono}></i>
        {tab.titulo}
      </button>
    ))}
  </div>
)

ResumenTabs.propTypes = {
  activa: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ResumenTabs
